(function () {
  const $carousels = $('.article-carousel-container');

  if ($carousels.length > 0) {
    $carousels
      .each(function () {
        const $container = $(this),
              $items = $container.find('.article-carousel-items'),
              $captions = $container.find('.article-carousel-captions'),
              $thumbs = $container.find('.article-carousel-thumbs'),
              $copy = $container.find('.article-carousel-copy'),
              cid = $container.data('carousel-id');

        if ($items.length) {
          $items.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 0,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            asNavFor: cid
          });
        }

        if ($captions.length) {
          $captions.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            rows: 0,
            draggable: false,
            swipe: false,
            fade: true
          });
        }

        if ($thumbs.length) {
          $thumbs.slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            rows: 0,
            focusOnSelect: true,
            centerPadding: '85px',
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            asNavFor: cid,
            centerMode: true,
          });
        }

        if ($copy.length) {
          $copy.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 0,
            arrows: false,
            draggable: false,
            swipe: false,
            fade: true
          });
        }
      });
  }
})();